<template>
    <div class="md user-lang" :class="[show? 'is-active': '']">
        <a @click.prevent.stop="toggle()" :title="$t('site.func.changelang')">
            <span class="name">{{ langTable[langID] }}</span>
        </a>
        <transition name="animate">
            <ul v-if="show" class="func" @click.stop>
                <li
                    v-for="(item, key) in langTable"
                    :class="langID === key? 'is-active': ''"
                    :key="key"
                >
                    <a class="icon-font language" @click.prevent="changeViewLang(key)">{{ langTable[key] }}</a>
                </li>
            </ul>
        </transition>
    </div>
</template>

<script>
    import { mapState, mapMutations } from 'vuex'

    export default {
        data: function(){

            return {
                id: 'user-lang',
                show: false,
                langTable: {
                    en: 'English',
                    zh: '繁體中文',
                }
            }
        },
        computed: {
            ...mapState([
                'langID',
            ]),
        },
        methods: {
            ...mapMutations([
                'globalClickFuncQueuePush',
                'globalClickFuncQueueRun',
                'globalClickFuncQueueClear',
                'initProductClassData',
                'initUserData',
                'setLang',
                'reload',
            ]),
            changeViewLang: function(lang){
                let _langID = this.langID;

                if( _langID !== lang ) {
                    
                    this.setLang({
                        id: lang,
                        callback: () => {
                            this.initProductClassData();
                            this.initUserData();
                        }
                    });
                }

                this.hide();
            },
            toggle: function(){
                this.globalClickFuncQueueRun(this.id);
                this.show = !this.show;
            },
            hide: function(){
                this.show = false;
            },
        },
        created: function(){
            this.globalClickFuncQueuePush({
                id: this.id,
                func: this.hide
            });
        },
        destroyed: function(){
            this.globalClickFuncQueueClear(this.id);
        }
    }
</script>

<style scoped lang="scss">
    
    .animate-enter-active {
        animation: animate-in .3s;
    }

    .animate-leave-active {
        animation: animate-out .2s;
    }

    @keyframes animate-in {
        0% {
            opacity: 0;
        }

        100% {
            opacity: 1;
        }
    }

    @keyframes animate-out {
        0% {
            opacity: 1;
        }

        100% {
            opacity: 0;
        }
    }

    .md.user-lang {
        @extend %header-btn;

        &.is-active {

            > a {
                background-color: $major-color;
            }
        }

        > a {
            padding-right: $interval-l;
            border-radius: 100px;
            border: $border;
            border-color: $white;

            @include media('mobile') {
                padding-right: 0;
                border-width: 0;
                // border-radius: $border-radius;
                background-color: transparent;
            }

            &::before {
                content: '\e894';
                margin-right: $interval-s;
            }

            &::after {
                content: '\e5c5';

                @include media('mobile') {
                    content: none;
                }
            }

            .name {

                @include media('mobile') {
                    display: none;
                }
            }
        }
    }
</style>
